export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG";

export const EDIT_PROFILE = "EDIT_PROFILE";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_ERROR = "PROFILE_ERROR";

export const EDIT_COMPANY = "EDIT_COMPANY";
export const EDIT_COMPANY_SUCCESS = "EDIT_COMPANY_SUCCESS";
export const EDIT_COMPANY_ERROR = "EDIT_COMPANY_ERROR";

export const ADD_LOCATION = "ADD_LOCATION";
export const ADD_LOCATION_SUCCESS = "ADD_LOCATION_SUCCESS";
export const ADD_LOCATION_ERROR = "ADD_LOCATION_ERROR";

export const LOCATION_LIST = "LOCATION_LIST";
export const LOCATION_LIST_SUCCESS = "LOCATION_LIST_SUCCESS";
export const LOCATION_LIST_ERROR = "LOCATION_LIST_ERROR";

export const MANAGER_LIST = "MANAGER_LIST";
export const MANAGER_LIST_SUCCESS = "MANAGER_LIST_SUCCESS";
export const MANAGER_LIST_ERROR = "MANAGER_LIST_ERROR";

export const ASSIGN_LOCATION = "ASSIGN_LOCATION";
export const ASSIGN_LOCATION_SUCCESS = "ASSIGN_LOCATION_SUCCESS";
export const ASSIGN_LOCATION_ERROR = "ASSIGN_LOCATION_ERROR";

export const GET_EMPLOYEE_BY_LOCATION = "GET_EMPLOYEE_BY_LOCATION";
export const GET_EMPLOYEE_BY_LOCATION_SUCCESS = "GET_EMPLOYEE_BY_LOCATION_SUCCESS";
export const GET_EMPLOYEE_BY_LOCATION_ERROR = "GET_EMPLOYEE_BY_LOCATION_ERROR";

export const GET_PARTICIPANT_BY_LOCATION = "GET_PARTICIPANT_BY_LOCATION";
export const GET_PARTICIPANT_BY_LOCATION_SUCCESS = "GET_PARTICIPANT_BY_LOCATION_SUCCESS";
export const GET_PARTICIPANT_BY_LOCATION_ERROR = "GET_PARTICIPANT_BY_LOCATION_ERROR";

export const GET_MANAGER_BY_ID = "GET_MANAGER_BY_ID";
export const GET_MANAGER_BY_ID_SUCCESS = "GET_MANAGER_BY_ID_SUCCESS";
export const GET_MANAGER_BY_ID_ERROR = "GET_MANAGER_BY_ID_ERROR";

export const UPDATE_MANAGER_DETAILS = "UPDATE_MANAGER_DETAILS";
export const UPDATE_MANAGER_DETAILS_SUCCESS = "UPDATE_MANAGER_DETAILS_SUCCESS";
export const UPDATE_MANAGER_DETAILS_ERROR = "UPDATE_MANAGER_DETAILS_ERROR";

export const DELETE_LOCATION = "DELETE_LOCATION";
export const DELETE_LOCATION_SUCCESS = "DELETE_LOCATION_SUCCESS";
export const DELETE_LOCATION_ERROR = "DELETE_LOCATION_ERROR";

export const LOGIN_AS_MANAGER = "LOGIN_AS_MANAGER";
export const LOGIN_AS_MANAGER_SUCCESS = "LOGIN_AS_MANAGER_SUCCESS";
export const LOGIN_AS_MANAGER_ERROR = "LOGIN_AS_MANAGER_ERROR";

export const LOGIN_AS_ADMIN = "LOGIN_AS_ADMIN";
export const LOGIN_AS_ADMIN_SUCCESS = "LOGIN_AS_ADMIN_SUCCESS";
export const LOGIN_AS_ADMIN_ERROR = "LOGIN_AS_ADMIN_ERROR";

export const AVAILABLE_LOCATIONS = "AVAILABLE_LOCATIONS";
export const AVAILABLE_LOCATIONS_SUCCESS = "AVAILABLE_LOCATIONS_SUCCESS";
export const AVAILABLE_LOCATIONS_ERROR = "AVAILABLE_LOCATIONS_ERROR";

export const SKIP_LOCATION = "SKIP_LOCATION";
export const SKIP_LOCATION_SUCCESS = "SKIP_LOCATION_SUCCESS";
export const SKIP_LOCATION_ERROR = "SKIP_LOCATION_ERROR";

export const NOTIFICATION = "NOTIFICATION";
export const NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS";
export const NOTIFICATION_ERROR = "NOTIFICATION_ERROR";

export const FREE_NOTIFICATION = "FREE_NOTIFICATION";
export const FREE_NOTIFICATION_SUCCESS = "FREE_NOTIFICATION_SUCCESS";
export const FREE_NOTIFICATION_ERROR = "FREE_NOTIFICATION_ERROR";

export const IS_USER_VALID = "IS_USER_VALID";

export const GET_USER_DATA = "GET_USER_DATA";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";

export const ADD_ADMIN_SWITCH_ACCOUNT = "ADD_ADMIN_SWITCH_ACCOUNT";
export const ADD_ADMIN_SWITCH_ACCOUNT_SUCCESS = "ADD_ADMIN_SWITCH_ACCOUNT_SUCCESS";
export const ADD_ADMIN_SWITCH_ACCOUNT_FAIL = "ADD_ADMIN_SWITCH_ACCOUNT_FAIL";
